import React from 'react'
import { Outlet } from 'react-router-dom'

const MainLayout = () => {
    return (
        <div className="mobile-wrapper">
            <Outlet/>
        </div>
    )
}

export default MainLayout